import { LanguageField } from '@mi-front/ui';

export function SocialLanguageField() {
  return <LanguageField name="language" allowEmpty />;
}
